module.exports = new __parcel__URL__("idea-engagement.c9b47ac0.svg").toString();